import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum SalesCaseLostReasonId {
  CONTACT_INVALID = 1,
  NO_PROPERTY = 2,
  EXISTING_CLIENT = 3,
  COMPETITION_SW = 4,
  NOT_SUITABLE = 5,
  CLOSING_DOWN = 6,
  NOT_FOUND = 7,
}

export class SalesCaseLostReason extends Codebook<SalesCaseLostReasonId> {
  static readonly CONTACT_INVALID = new SalesCaseLostReason(
    SalesCaseLostReasonId.CONTACT_INVALID,
    () => $t('The contact is not valid (fake/test sales case)'),
  )

  static readonly NO_PROPERTY = new SalesCaseLostReason(SalesCaseLostReasonId.NO_PROPERTY, () =>
    $t('Not an accommodation property (guest trying to checkin, etc)'),
  )

  static readonly EXISTING_CLIENT = new SalesCaseLostReason(
    SalesCaseLostReasonId.EXISTING_CLIENT,
    () => $t('Existing client (new staff training)'),
  )

  static readonly COMPETITION_SW = new SalesCaseLostReason(
    SalesCaseLostReasonId.COMPETITION_SW,
    () => $t('Happy with competition SW'),
  )

  static readonly NOT_SUITABLE = new SalesCaseLostReason(SalesCaseLostReasonId.NOT_SUITABLE, () =>
    $t('Previo is not suitable for them'),
  )

  static readonly CLOSING_DOWN = new SalesCaseLostReason(SalesCaseLostReasonId.CLOSING_DOWN, () =>
    $t('Intend to sell the property (or close down)'),
  )

  static readonly NOT_FOUND = new SalesCaseLostReason(SalesCaseLostReasonId.NOT_FOUND, () =>
    $t('No reason found'),
  )

  private constructor(
    id: SalesCaseLostReasonId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
